// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2KV8W","requiredAsterisk":"Info_requiredAsterisk__uHYaP"};